import axios from 'axios';
import { global } from 'config';

axios.defaults.baseURL = global.domain;
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';


const request = ({
    url,
    method = 'POST',
    data,
    params,
    headers
}) => {
    // return new Promise((resolve, reject) => {
    //     switch (method.toLocaleUpperCase()) {
    //         case 'POST':
    //             // post
    //             axios({
    //                 url,
    //                 method,
    //                 data,
    //                 headers
    //             }).then(res => resolve(res)).catch(err => reject(err));
    //             break;

    //         default:
    //             // put delete get
    //             axios({
    //                 url,
    //                 method,
    //                 params,
    //                 headers
    //             }).then(res => resolve(res)).catch(err => reject(err));
    //             break;
    //     }
    // })

    switch (method.toLocaleUpperCase()) {
        case 'POST':
            // post
            return axios({
                url,
                method,
                data,
                headers
            })
        // break;

        default:
            // put delete get
            return axios({
                url,
                method,
                params,
                headers
            })
        // break;
    }
}

export default request;